import apiClient from './api';

export interface DashboardStats {
  voicesCount: number;
  audioTranslationsCount: number;
  audioTotalDuration: number;
  videoTranslationsCount: number;
  videoTotalDuration: number;
  speechToTextCount: number;
  speechToTextTotalDuration: number;
  textToSpeechCount: number;
  textToSpeechTotalDuration: number;
}

export interface LatestVoice {
  id: string;
  name: string;
  language: string;
  status: string;
  usageCount: number;
  createdAt: string;
}

export interface LatestVideo {
  id: string;
  jobId: string;
  title?: string;
  status: string;
  targetLanguage: string;
  videoMode: string;
  duration: number;
  createdAt: string;
}

export interface LatestAvatar {
  id: string;
  name: string;
  imageUrl: string;
  isLibrary: boolean;
  usageCount: number;
  createdAt: string;
}

export interface LatestSttJob {
  id: string;
  jobId: string;
  title?: string;
  status: string;
  language: string;
  duration: number;
  wordCount: number;
  createdAt: string;
}

export interface LatestTtsJob {
  id: string;
  jobId: string;
  title?: string;
  status: string;
  duration: number;
  format: string;
  createdAt: string;
}

export interface LatestWork {
  voices: LatestVoice[];
  videos: LatestVideo[];
  speechToTextJobs: LatestSttJob[];
  textToSpeechJobs: LatestTtsJob[];
  avatars: LatestAvatar[];
}

export interface DashboardResponse {
  success: boolean;
  data: {
    stats: DashboardStats;
    latest: LatestWork;
  };
}

export const dashboardApi = {
  getStats: async (): Promise<DashboardResponse> => {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
  },
};
